import { SyringeModule } from './syringe-module';
export * from './syringe-module';
export function Module(register) {
  return new SyringeModule(register);
}